/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// THIS FILE IS GENERATED BY BUILD TOOL
// DO NOT EDIT IT MANUAL
import { wrapIcon } from '../../wrapIcon';
import { SVGProps } from 'react';
const SvgDatabasePlugBase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M18.5 4.60774C18.5 6.71067 15.1421 8.41543 11 8.41543C6.85786 8.41543 3.5 6.71067 3.5 4.60774M18.5 4.60774C18.5 2.50481 15.1421 0.800049 11 0.800049C6.85786 0.800049 3.5 2.50481 3.5 4.60774M18.5 4.60774V8.06928M3.5 4.60774V14.9924C3.5 17.0953 6.5 19 10 19M3.5 4.60774V8.06928M18.5 11V8.06928M10 15.5C6.5 15.5 3.5 13.6337 3.5 11.5308V8.06928M18.5 8.06928C18.5 10.1722 15.1421 11.877 11 11.877C6.85786 11.877 3.5 10.1722 3.5 8.06928M15.0769 16.3308V14M18.6923 16.3308V14M16.8846 21.3923V23.2M18.3044 21.3924H15.4649C14.2522 21.3924 13.2692 20.4094 13.2692 19.1968V17.0627C13.2692 16.6585 13.5969 16.3309 14.0011 16.3309H19.7681C20.1723 16.3309 20.5 16.6585 20.5 17.0627V19.1968C20.5 20.4094 19.517 21.3924 18.3044 21.3924Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const SvgDatabasePlug = wrapIcon(SvgDatabasePlugBase);
export default SvgDatabasePlug;
